export * from './catalogs/catalogs.component';
export * from './categories/categories.component';
export * from './product-link/product-link.component';
export * from './products/products.component';
export * from './base-formation';
export * from './catalogs-formations.module';
